import { useQuery } from 'react-query';
import { useMutation } from 'react-query';
import {
  getDrugSearchResult,
  getDrugInfoResult,
  getDrugCompareResult,
} from '@/api//farmasep';

export function useDrugSearchResult(searchString, zip) {
  const result = useQuery({
    queryKey: ['drugSearch', searchString, zip],
    queryFn: () => getDrugSearchResult(searchString, zip),
  });

  const { isLoading, data } = result;

  return { isLoading, data };
}

export function useDrugInfoResult({ onSuccess }) {
  const result = useMutation(({ drug, zip }) => getDrugInfoResult(drug, zip), {
    onSuccess,
  });

  const { isLoading, mutate } = result;

  return {
    isLoading,
    drugInfoResult: mutate,
  };
}

export function useDrugCompareResult({ onSuccess }) {
  const result = useMutation(
    ({ searchString, zip, form, dosage, qty }) =>
      getDrugCompareResult(searchString, zip, form, dosage, qty),
    {
      onSuccess,
    }
  );

  const { isLoading, mutate } = result;

  return {
    isLoading,
    drugCompareResult: mutate,
  };
}
